import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { FolderKanban, Newspaper, Megaphone, Briefcase, MessageSquareQuote, HelpCircle, Users, CalendarDays, Inbox } from "lucide-react";

export function StatsDashboard({ onNavigate }) {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get("/admin/stats").then((r) => setStats(r.data)).catch(() => setStats({}));
  }, []);

  const cards = [
    { label: "Total Projects", value: stats?.projects, icon: FolderKanban, color: "#FF8800", tab: "projects" },
    { label: "Blog Posts", value: stats?.posts, icon: Newspaper, color: "#00B0FF", tab: "posts" },
    { label: "News", value: stats?.news, icon: Megaphone, color: "#00E676", tab: "news" },
    { label: "Open Careers", value: stats?.open_careers, icon: Briefcase, color: "#FF8800", tab: "jobs" },
    { label: "Testimonials", value: stats?.testimonials, icon: MessageSquareQuote, color: "#00B0FF", tab: "testimonials" },
    { label: "FAQs", value: stats?.faqs, icon: HelpCircle, color: "#00E676", tab: "faqs" },
    { label: "Team Members", value: stats?.team, icon: Users, color: "#FF8800", tab: "team" },
    { label: "Upcoming Events", value: stats?.upcoming_events, icon: CalendarDays, color: "#00B0FF", tab: "events" },
    { label: "Contact Enquiries", value: stats?.enquiries, icon: Inbox, color: "#00E676", tab: "enquiries", sub: stats ? `${stats.new_enquiries} new` : "" },
  ];

  return (
    <div data-testid="admin-stats-dashboard">
      <div className="mb-8">
        <h2 className="font-display text-2xl font-bold text-white">Dashboard</h2>
        <p className="text-sm text-slate-400">Overview of the LaunchLab website content.</p>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
        {cards.map((c) => (
          <button
            key={c.label}
            onClick={() => onNavigate(c.tab)}
            data-testid={`stats-card-${c.label.toLowerCase().replace(/\s+/g, "-")}`}
            className="glass rounded-xl p-5 text-left transition-all duration-300 hover:-translate-y-1 hover:border-[#FF8800]/40 group"
          >
            <div className="w-10 h-10 rounded-lg flex items-center justify-center mb-4" style={{ background: `${c.color}14`, border: `1px solid ${c.color}33` }}>
              <c.icon className="w-4.5 h-4.5" style={{ color: c.color }} strokeWidth={1.8} />
            </div>
            <p className="font-display font-extrabold text-3xl text-white">
              {c.value ?? "—"}
              {c.sub && <span className="ml-2 text-xs font-normal text-[#FF8800]">{c.sub}</span>}
            </p>
            <p className="text-xs text-slate-400 mt-1 font-mono-tech tracking-wider uppercase group-hover:text-slate-200 transition-colors">{c.label}</p>
          </button>
        ))}
      </div>
    </div>
  );
}
